import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import type { CommonStepAttributes } from '../../ui/utils/analytics/analyticsFlowTypes';
import { META_UPDATE_COMMON_ATTRIBUTES } from './ai-monitor-watchmen-plugin';

export const getMonitorWatchmenCommands = (view: EditorView) => ({
	syncCommonAttributes: (attributes: Partial<CommonStepAttributes>): void =>
		view.dispatch(view.state.tr.setMeta(META_UPDATE_COMMON_ATTRIBUTES, attributes)),
});
